import { useMutation, useQueryClient } from '@tanstack/react-query';
import { claimQuest } from '@/lib/api';
import { apiErrorCode } from '@/lib/apiErrors';
import type { ClaimQuestResponse } from '@/lib/types';

export function useClaimQuest() {
  const qc = useQueryClient();
  return useMutation<ClaimQuestResponse, Error, string>({
    mutationFn: (id: string) => claimQuest(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['quests'] });
      qc.invalidateQueries({ queryKey: ['me'] });
      qc.invalidateQueries({ queryKey: ['leaderboard'] });
      qc.invalidateQueries({ queryKey: ['participantProfile'] });
    },
    onError: (err) => {
      // Claimed elsewhere (another tab/device): the cached list is stale, so
      // refetch to flip the card to completed instead of offering a dead claim.
      if (apiErrorCode(err) === 'quest_already_completed') {
        qc.invalidateQueries({ queryKey: ['quests'] });
        qc.invalidateQueries({ queryKey: ['me'] });
      }
    },
  });
}
